import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { UserActions } from './user.actions';
import { HomiSettingsActions } from '@lyceo/shared/homi-settings/data-access';

export const USER_FEATURE_KEY: string = 'user';

export interface UserState {
  planPermissions: CallState;
  personId: string | undefined;
  personIdCallState: CallState;
}

export const initialUserState: UserState = {
  planPermissions: LoadingState.INIT,
  personIdCallState: LoadingState.INIT,
  personId: undefined,
};

const reducer: ActionReducer<UserState, Action> = createReducer(
  initialUserState,
  on(
    HomiSettingsActions.getSettingsFailure,
    UserActions.planPermissionsLoaded,
    (state): UserState => ({
      ...state,
      planPermissions: LoadingState.LOADED,
    }),
  ),
  on(
    UserActions.loadPersonId,
    (state): UserState => ({
      ...state,
      personIdCallState: LoadingState.LOADING,
    }),
  ),
  on(
    UserActions.loadPersonIdSuccess,
    (state, { personId }): UserState => ({
      ...state,
      personId: personId,
      personIdCallState: LoadingState.LOADED,
    }),
  ),
  on(
    UserActions.loadPersonIdFailure,
    (state, { error }): UserState => ({
      ...state,
      personIdCallState: { errorMsg: error.message },
    }),
  ),
);

export function userReducer(
  state: UserState | undefined,
  action: Action,
): UserState {
  return reducer(state, action);
}
